import { Injectable } from "@angular/core";
import { io, Socket } from 'socket.io-client';
import { environment } from '../environments/environment';
import { StorageType } from './authentication.service';

@Injectable()
export class SocketIoService {
  socket:Socket;

  constructor() {
  }

  setupSocketConnection() {
    //currently use for login tracking
    //after login then establish socket connection
    //in nginx server we set the websocket with path "/ws"
    //by default it will auto reconnect
    this.socket = io(environment.SocketEndpoint,{
      path:environment.Env !== "Local-" ? "/ws": "",
      auth:{
        token: sessionStorage.getItem(StorageType.ACCESS)//get the token after login for verification
      }
    });
    this.logUserOnlineStatus();

    //the reconnect event on Manager instance instead of socket instance
    this.socket.io.on("reconnect", () => {
      this.logUserOnlineStatus();
    });
  }

  logUserOnlineStatus(){
    this.socket.emit("login",sessionStorage.getItem(StorageType.ACCESS));
  }

  socketDisconnection() {
    //disconnet the socket when logout
  this.socket.disconnect();
  }

}
